import React, { useState, useEffect } from "react";
import { WarsEvents, LoadSceneEvent, WarsScenes } from "@playroomkit/pr-wars/events"
import './RestartApp.css';

const RestartApp: React.FC = () => {
    
    const [showUI, setShowUI] = useState(false);

    useEffect(() => {
        const handleLoadSceneEvent = (event: Event) => {
            let e = event as LoadSceneEvent;
            
            setShowUI(e.sceneName === WarsScenes.Restart);
        }

        document.addEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvent);

        return () => {
          document.removeEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvent);
        }
    });

    const handleRestart = () => {
        window.location.reload();
    };

    return (
        <>
        {showUI && (
          <div className="error-container">
          <img
            src="img/error.png" // Replace with your image path
            alt="Broken Robot"
            className="error-image"
          />
          <button onClick={handleRestart} className="error-button">
            Restart
          </button>
        </div>
        )}
        </>
    );
};

export default RestartApp;